import request from '../utils/request';

const url = 'scenic-spot/notice/';

export function list(): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    request({
      url: `${url}effective`,
      method: 'get'
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  });
}

export function getYiQing(): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    request({
      url: `${url}`,
      method: 'get',
      params: {
        mold: 30,
        maxResultCount: 1
      }
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  });
}
